import type { CommandData } from '@festina/unitlink-general-types/unitlink'

import { PortfolioCommandModalButtonFallback } from '../PortfolioCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'
import { fundCommands } from './fundCommands'
import { portfolioCommands } from './portfolioCommands'

export const unitlinkCommands: CommandDataRecord<CommandData['_type']> = {
  AnnotationCommandData: PortfolioCommandModalButtonFallback,
  ...fundCommands,
  ...portfolioCommands,
}
